<div class="mb-27 mct-flex mct-row mct-justify-between mct-items-start"  >
  <h4>{{ 'profiles.view.committees.label' | translate | titlecase }}</h4>
  <a
    class="f-wb"
    *wlAccessControl="{ SecurityElement: securityElementNames.ProfileCommittees_Tab, MinimumAccessLevel: 2 }"
    [hidden]="profileIsOrg"
    (click)="showAddDialog()"
  >
    {{ 'profiles.view.committees.add-to-committee' | translate | ucfirst }}
    <i class="pi pi-angle-double-right"></i>
  </a>
</div>
<div *ngFor="let committee of committees.Result; last as isLast">
  <div>
    <a [routerLink]="['/profiles/committee', committee.CommitteeID]" [ngClass]="committee.Active ? 'f-wb' : 'f-wb light-text'">{{
      committee.Name
    }}</a>
  </div>
  <div *ngFor="let member of committee.CommitteeMembers; first as isFirst">
    <div class="mct-grid mct-cols-1-1"  gdRows="*" [ngClass]="member.Active ? (committee.Active ? 'mb-10' : 'mb-10 light-text') : 'mb-10 light-text'">
      <ng-container *ngIf="profileIsOrg">
        <div [ngClass]="isFirst ? 'mt-10' : ''">
          <a
            [routerLink]="['/profile', member.ProfileID]"
            [ngClass]="member.Active ? (committee.Active ? '' : 'light-text') : 'light-text'"
          >
            {{ member.Profile?.ReportName }}
          </a>
        </div>
        <div  class="mct-flex light-text mct-justify-end mct-items-end">{{ member.Title }}</div>
        <div>{{ member.MemberSince | date : 'M/d/yyyy' }}</div>
        <div class="mct-flex mct-justify-end mct-items-stretch" *ngIf="member.Active"  [hidden]="member.TermExpires <= member.MemberSince">
          {{ member.TermExpires | date : 'M/d/yyyy' }}
        </div>
        <div class="mct-flex mct-justify-end mct-items-stretch" *ngIf="!member.Active" >
          {{ member.DateInactive | date : 'M/d/yyyy' }}
        </div>
      </ng-container>
      <ng-container *ngIf="!profileIsOrg">
        <div [ngClass]="member.Title ? 'mt-10 light-text' : ''">
          {{ member.Title }}
        </div>
        <div  class="mct-flex light-text mct-justify-end mct-items-stretch"></div>
        <div>{{ member.MemberSince | date : 'M/d/yyyy' }}</div>
        <div class="mct-flex mct-justify-end mct-items-stretch" *ngIf="member.Active"  [hidden]="member.TermExpires <= member.MemberSince">
          {{ member.TermExpires | date : 'M/d/yyyy' }}
        </div>
        <div class="mct-flex mct-justify-end mct-items-stretch" *ngIf="!member.Active" >
          {{ member.DateInactive | date : 'M/d/yyyy' }}
        </div>
      </ng-container>
    </div>
  </div>
  <hr class="mt-27 mb-27" [hidden]="isLast" />
</div>
<div class="mt-54">
  <p-checkbox
    name="includeInactive"
    binary="true"
    [(ngModel)]="search.IncludeInactive"
    (onChange)="loadCommittees(1, false)"
    inputId="includeInactive"
  >
  </p-checkbox>
  <label for="includeInactive">
    {{ 'profiles.view.committees.include-inactive' | translate | ucfirst }}
  </label>
</div>
<div class="f-wb">
  <wl-paging-controls
    #pagingControls
    [pagedResult]="committees"
    [hidden]="!showPaging"
    (pagingEvent)="onPagingEvent($event)"
  ></wl-paging-controls>
</div>
<wl-profile-add-to-committee></wl-profile-add-to-committee>
